export enum Currency {
	CZK = "CZK",
	EUR = "EUR",
}
